import { memo } from 'react';
import { AppIconNaverOn, AppIconNaverOff, AppIconNpayOn, AppIconNpayOff } from '@defign/ui';
import classNames from '../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/bind.mjs';
import { APP_ENVIRONMENT, OS_ENVIRONMENT } from '../../share/constants.mjs';
import style from './Selector.module.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

const cx = classNames.bind(style);
const AppSelector = /*#__PURE__*/memo(_ref => {
  let {
    appEnv,
    setAppEnv
  } = _ref;
  return /*#__PURE__*/jsx("div", {
    className: cx('app-selector'),
    children: /*#__PURE__*/jsxs("div", {
      className: cx('inner'),
      children: [/*#__PURE__*/jsx("div", {
        className: cx('button-box'),
        children: /*#__PURE__*/jsxs("button", {
          type: "button",
          onClick: () => setAppEnv(APP_ENVIRONMENT.NAVER_APP),
          className: cx('button', 'naver', {
            selected: appEnv === APP_ENVIRONMENT.NAVER_APP
          }),
          children: [/*#__PURE__*/jsx("span", {
            className: cx('icon'),
            children: appEnv === APP_ENVIRONMENT.NAVER_APP ? /*#__PURE__*/jsx(AppIconNaverOn, {
              width: 20,
              height: 20
            }) : /*#__PURE__*/jsx(AppIconNaverOff, {
              width: 20,
              height: 20
            })
          }), "\uB124\uC774\uBC84\uC571", appEnv === APP_ENVIRONMENT.NAVER_APP && /*#__PURE__*/jsx("span", {
            className: "blind",
            children: "\uC120\uD0DD\uB428"
          })]
        })
      }), /*#__PURE__*/jsx("div", {
        className: cx('button-box'),
        children: /*#__PURE__*/jsxs("button", {
          type: "button",
          onClick: () => setAppEnv(APP_ENVIRONMENT.PAY_APP),
          className: cx('button', 'pay', {
            selected: appEnv === APP_ENVIRONMENT.PAY_APP
          }),
          children: [/*#__PURE__*/jsx("span", {
            className: cx('icon'),
            children: appEnv === APP_ENVIRONMENT.PAY_APP ? /*#__PURE__*/jsx(AppIconNpayOn, {
              width: 20,
              height: 20
            }) : /*#__PURE__*/jsx(AppIconNpayOff, {
              width: 20,
              height: 20
            })
          }), "\uB124\uC774\uBC84\uD398\uC774\uC571", appEnv === APP_ENVIRONMENT.PAY_APP && /*#__PURE__*/jsx("span", {
            className: "blind",
            children: "\uC120\uD0DD\uB428"
          })]
        })
      })]
    })
  });
});
const OSSelector = /*#__PURE__*/memo(_ref2 => {
  let {
    osEnv,
    setOsEnv
  } = _ref2;
  return /*#__PURE__*/jsxs("div", {
    className: cx('os-selector'),
    children: [/*#__PURE__*/jsxs("span", {
      className: cx('radio-box', {
        selected: osEnv === OS_ENVIRONMENT.ANDROID
      }),
      children: [/*#__PURE__*/jsx("input", {
        type: "radio",
        name: "_QR_BRDGIE_OS",
        id: "_QR_BRDGIE_ANDROID",
        className: cx('input'),
        onClick: () => setOsEnv(OS_ENVIRONMENT.ANDROID)
      }), /*#__PURE__*/jsx("label", {
        htmlFor: "_QR_BRDGIE_ANDROID",
        className: cx('label'),
        children: "Android"
      })]
    }), /*#__PURE__*/jsxs("span", {
      className: cx('radio-box', {
        selected: osEnv === OS_ENVIRONMENT.IOS
      }),
      children: [/*#__PURE__*/jsx("input", {
        type: "radio",
        name: "_QR_BRDGIE_OS",
        id: "_QR_BRDGIE_IOS",
        className: cx('input'),
        onClick: () => setOsEnv(OS_ENVIRONMENT.IOS)
      }), /*#__PURE__*/jsx("label", {
        htmlFor: "_QR_BRDGIE_IOS",
        className: cx('label'),
        children: "iOS"
      })]
    })]
  });
});

export { AppSelector, OSSelector };
